import { deleteCookie, getCookie, setCookie, } from './cookies';
// Cookie names for impersonation
export const IMPERSONATION_COOKIE_NAME = 'X-Impersonate-Id';
export const IMPERSONATION_KIT_COOKIE_NAME = 'X-Impersonate-Kit-Id';
/**
 * Set impersonation cookie for partner impersonation
 * @param partnerId - ID of the partner to impersonate
 * @param options - Optional cookie options
 * @param context - Server-side context for setting headers
 */
export function setImpersonationCookie(partnerId, options, context) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    const cookieOptions = {
        ...(options?.scope !== 'host-only' && rootDomain ? { domain: rootDomain } : {}),
        sameSite: 'lax',
        maxAge: 60 * 60, // 60 minutes
        path: '/',
        ...options,
    };
    setCookie(IMPERSONATION_COOKIE_NAME, partnerId, cookieOptions, context);
}
/**
 * Get impersonation cookie
 * @param context - Server-side context for reading request
 * @returns The impersonation ID or undefined
 */
export function getImpersonationCookie(context) {
    return getCookie(IMPERSONATION_COOKIE_NAME, context);
}
/**
 * Delete impersonation cookie
 * @param options - Cookie options (path, domain)
 * @param context - Server-side context for setting headers
 */
export function deleteImpersonationCookie(options, context) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    const deleteOptions = {
        ...(options?.scope !== 'host-only' && rootDomain ? { domain: rootDomain } : {}),
        path: '/',
        ...(options || {}),
    };
    deleteCookie(IMPERSONATION_COOKIE_NAME, deleteOptions, context);
}
/**
 * Set impersonation kit cookie for kit-scoped impersonation
 * @param kitId - ID of the kit to impersonate
 * @param options - Optional cookie options
 * @param context - Server-side context for setting headers
 */
export function setImpersonationKitCookie(kitId, options, context) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    const cookieOptions = {
        ...(options?.scope !== 'host-only' && rootDomain ? { domain: rootDomain } : {}),
        sameSite: 'lax',
        maxAge: 60 * 60, // 60 minutes
        path: '/',
        ...options,
    };
    setCookie(IMPERSONATION_KIT_COOKIE_NAME, kitId, cookieOptions, context);
}
/**
 * Get impersonation kit cookie
 * @param context - Server-side context for reading request
 * @returns The impersonation kit ID or undefined
 */
export function getImpersonationKitCookie(context) {
    return getCookie(IMPERSONATION_KIT_COOKIE_NAME, context);
}
/**
 * Delete impersonation kit cookie
 * @param options - Cookie options (path, domain)
 * @param context - Server-side context for setting headers
 */
export function deleteImpersonationKitCookie(options, context) {
    const rootDomain = import.meta.env.VITE_ROOT_DOMAIN;
    const deleteOptions = {
        ...(options?.scope !== 'host-only' && rootDomain ? { domain: rootDomain } : {}),
        path: '/',
        ...(options || {}),
    };
    deleteCookie(IMPERSONATION_KIT_COOKIE_NAME, deleteOptions, context);
}
//# sourceMappingURL=impersonation.js.map